// Multi-lens camera helpers. Phones expose several back cameras (ultra-wide / wide / tele);
// once permission is granted, enumerateDevices() returns them with labels.

function shortLabel(label, i) {
  if (!label) return `Lens ${i + 1}`;
  const l = label.toLowerCase();
  if (l.includes("ultra")) return "Ultra-wide";
  if (l.includes("tele")) return "Telephoto";
  if (l.includes("front") || l.includes("user")) return "Front";
  if (l.includes("dual") || l.includes("triple")) return "Wide";
  if (l.includes("back") || l.includes("rear") || l.includes("environment")) return "Wide";
  return label.length > 14 ? `Lens ${i + 1}` : label;
}

export async function listCameras() {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices
      .filter((d) => d.kind === "videoinput")
      .map((d, i) => ({ deviceId: d.deviceId, label: shortLabel(d.label, i) }));
  } catch {
    return [];
  }
}

export function videoConstraints(deviceId, facing) {
  return deviceId ? { deviceId: { exact: deviceId } } : { facingMode: facing };
}
